import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getPartnerPlayersSummary } from '../../services'
import { PartnerQueryKeys } from '@/modules/manage-player/keys'
import {
	GetPartnerPlayersSummaryRequest,
	GetPartnerPlayersSummaryResponse,
} from '@/modules/manage-player/type'

export default function useQueryGetPartnerPlayersSummary(
	partnerId: string,
	payload: GetPartnerPlayersSummaryRequest,
	props?: UseBaseQueryOptions<GetPartnerPlayersSummaryResponse>,
) {
	return useQuery({
		queryKey: [PartnerQueryKeys.GetPartnerPlayersSummary, partnerId, payload],
		queryFn: () => getPartnerPlayersSummary(partnerId, payload),
		enabled: !!partnerId,
		// Keep previous data while fetching new summary (useful for date filter changes)
		placeholderData: (previousData) => previousData,
		...props,
	})
}
